import styled from "@emotion/styled";
import { Flex } from "@otrium/core";
import { Divider } from "src/atoms/Divider";
import { Heading } from "@otrium/atoms";

const StyledBrandName = styled.div`
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 1.6px;
  color: ${({ theme }) => theme.colors.tone.black};
  margin-top: ${({ theme }) => theme.space[0]}px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledBrandNameLink = styled.a`
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 1.6px;
  color: ${({ theme }) => theme.colors.tone.black};
  margin-top: ${({ theme }) => theme.space[0]}px;

  @media (max-width: ${({ theme }) => theme.breakpoints[2]}) {
    margin-top: ${({ theme }) => theme.space[5]}px;
  }
`;

const StyledProductHeading = styled(Heading)`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fonts.body};
`;

const StyledProductName = styled.p`
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  line-height: 24px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  text-transform: lowercase;
  font-weight: 400;
  &:first-letter {
    text-transform: capitalize;
  }
`;

const PriceWrapper = styled(Flex)`
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.space[2]}px;
  font-size: ${({ theme }) => theme.fontSizes.fontSize20};
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.colors.semantic.red};
  align-items: center;

  p {
    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.space.space8};
  }

  .promo-code {
    display: inline-flex;
    place-items: center;
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: ${({ theme }) => theme.fontWeights.body};

    svg {
      width: ${({ theme }) => theme.fontSizes.fontSize14};
      height: ${({ theme }) => theme.fontSizes.fontSize14};
    }
  }
`;

const AdditionalPrice = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  font-weight: normal;
  text-decoration: line-through;
`;
const PriceNoteText = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  font-weight: normal;
`;

const VerticalDivider = styled(Divider)`
  width: 1px;
  height: 14px;
  background-color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  margin: 0 ${({ theme }) => theme.space[2]}px;
`;

export {
  PriceWrapper,
  AdditionalPrice,
  PriceNoteText,
  StyledBrandName,
  StyledBrandNameLink,
  StyledProductName,
  StyledProductHeading,
  VerticalDivider,
};
